<div class="login-page">

  <!-- brand side -->
  <aside class="brand">
    <div class="brand-inner">
      <div class="brand-logo"><mat-icon>credit_card</mat-icon></div>
      <h1>{{'cardsrecharged' | translate}}</h1>
      <p>{{'login' | translate}}</p>
      <div class="brand-cards">
        <span class="card c1"></span>
        <span class="card c2"></span>
        <span class="card c3"></span>
      </div>
    </div>
  </aside>

  <!-- form side -->
  <main class="panel">
    <div class="login-card">
      <div class="login-head">
        <div class="login-icon"><mat-icon>lock</mat-icon></div>
        <h2>{{'login' | translate}}</h2>
      </div>

      <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="outline">
          <mat-label>{{'userName' | translate}}</mat-label>
          <mat-icon matPrefix>person_outline</mat-icon>
          <input type="text" matInput formControlName="username" autocomplete="username">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{'password' | translate}}</mat-label>
          <mat-icon matPrefix>lock_outline</mat-icon>
          <input #pw type="password" matInput formControlName="password" autocomplete="current-password">
          <button type="button" mat-icon-button matSuffix tabindex="-1"
            (click)="pw.type = pw.type === 'password' ? 'text' : 'password'">
            <mat-icon>{{pw.type === 'password' ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-icon matPrefix>language</mat-icon>
          <mat-select [(value)]="selectedLang" (selectionChange)="selectChange()">
            @for (item of lang; track item) {
              <mat-option [value]="item.id">
                {{item.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (error) {
          <div class="error">
            <mat-icon>error_outline</mat-icon>
            <span>{{ error }}</span>
          </div>
        }

        <button type="submit" class="submit" mat-flat-button [disabled]="form.invalid">
          {{'login' | translate}}
        </button>

        <a class="forgot" routerLink="./resetpass">{{'forgetpassword' | translate}}</a>
      </form>
    </div>
  </main>
</div>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>
